export const isTestEnv = process.env.NEXT_PUBLIC_IS_TEST_ENV === "true";
export const skipVerification =
  process.env.NEXT_PUBLIC_SKIP_VERIFICATION === "true";
